module.exports = __webpack_public_path__ + "img/Logo-Verde.169afbf0.svg";